<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0">
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-2 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Pilih Jenis Transaksi
						</div>
						<div class="col-12 pl-0 pr-0 pb-1 pt-2 justify-content-center d-flex">
							<div class="col-6 pl-0 pr-0 w-100">
								<button class="btn rounded-cus box-purple w-100" @click="changeTransaction('member')"
									:class="{ 'btn-blue': transactionType == 'member', 'btn-outline-white': transactionType != 'member' }">
									Member
								</button>
							</div>
							<div class="col-6">
								<button class="btn rounded-cus box-purple w-100" @click="changeTransaction('non-member')"
									:class="{ 'btn-blue': transactionType == 'non-member', 'btn-outline-white': transactionType != 'non-member' }">
									Non Member
								</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap"
					v-if="transactionType == 'non-member' && !prospectiveMember.status">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Masukan Data Calon Mitra
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Nama Calon Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1 pb-1">
								<span class="icon-mitra-code"><i class="fas fa-user"></i></span>
								<input v-model="prospectiveMember.name" placeholder="Masukan Nama Calon Mitra"
									class="input-mitra-code form-control box-blue rounded-cus font-size-10" type="text">
							</div>
							<AlertInput v-if="alert_name" :message="alert_name" />
						</div>
						<div class="col-12 pl-0 pr-0 pt-2 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">No. HP Calon Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1 pb-1">
								<span class="icon-mitra-code"><i class="fas fa-mobile"></i></span>
								<input v-model="prospectiveMember.mobilephone" placeholder="Masukan No. HP Calon Mitra"
									class="input-mitra-code form-control box-blue rounded-cus font-size-10" type="text">
							</div>
							<AlertInput v-if="alert_mobilephone" :message="alert_mobilephone" />
						</div>
						<!-- <div class="font-size-8 pt-1 color-orange">Contoh : GSXXXXXX</div> -->
						<div class="col-12 pl-0 pr-0 pb-2 text-center pt-2">
							<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="checkProspectiveMitra">
								<div class="font-size-11 text-uppercase">Selanjutnya</div>
							</button>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap"
					v-if="((!mitraMLM.status || mitraMLM.is_active == '0') && transactionType == 'member') || ((!mitraMLM.status || mitraMLM.is_active == '0') && prospectiveMember.status)">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Masukan Kode Mitra
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Kode Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1 pb-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/gs-icon.svg"></span>
								<!-- <input v-model="mitra_code" placeholder="Contoh : GSXXXXXX " class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold text-uppercase" type="text" @keyup.enter = "checkMitra"> -->
								<v-select v-model="mitra_code" :options="memberHasTransaction" appendToBody placeholder="Contoh : GSXXXXXX"
									class="input-mitra-code box-blue rounded-cus font-size-10 font-weight-bold" label="member_text" taggable
									:create-option="el => ({ member_network_mid: el, member_name: '', member_text: el })"
									:reduce="el => `${el.member_network_mid}`" @input="checkMitra">
									<template v-slot:no-options>
										Belum ada mitra yang melakukan transaksi
									</template>
								</v-select>
							</div>
							<AlertInput v-if="alert_mitra" :message="alert_mitra" />
						</div>
						<!-- <div class="font-size-8 pt-1 color-orange">Contoh : GSXXXXXX</div> -->
						<div class="col-12 pl-0 pr-0 pb-2 text-center pt-2">
							<button v-if="prospectiveMember.status == true"
								class="col-5 col-md-3 btn btn-outline-danger rounded-cus mr-4 mr-md-3" @click="prospectiveMember.status = false">
								<div class="font-size-11 text-uppercase">kembali</div>
							</button>
							<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="checkMitra">
								<div class="font-size-11 text-uppercase">Cek Mitra</div>
							</button>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap"
					v-if="mitraMLM.status && mitraMLM.is_active == '1'">
					<div class="col-lg-12 pl-0 pr-0" v-if="prospectiveMember.status">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Data Calon Mitra
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Nama Calon Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/user-solid.svg"></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold"
									type="text" :value="prospectiveMember.name.toUpperCase()">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">No. HP Calon Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><i class="fas fa-mobile"></i></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold"
									type="text" :value="prospectiveMember.mobilephone">
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0" v-if="prospectiveMember.status">
						<div class="col-12 pt-3 border-bottom"></div>
					</div>
					<div class="col-lg-12 pl-0 pt-2 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Data Mitra
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Kode Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/mb-icon.svg"></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold"
									type="text" :value="mitraMLM.network_mid.toUpperCase()">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Nama Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/user-solid.svg"></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold"
									type="text" :value="mitraMLM.name.toUpperCase()">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Kota Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><i class="fas fa-map-marker-alt"></i></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold"
									type="text" :value="kotaprovinsi">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-2 d-flex justify-content-center">
							<button class="col-5 col-md-3 btn btn-outline-danger rounded-cus mr-4 mr-md-3" @click="resetmitraMLM">
								<div class="font-size-11 text-uppercase">kembali</div>
							</button>
							<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="lanjut">
								<div class="font-size-11 text-uppercase">selanjutnya</div>
							</button>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import AlertInput from '@/components/elements/alert/AlertInput.vue';
export default {
	components: {
		AlertInput
	},
	data() {
		return {
			mitra_code: '',
			alert_mitra: '',
			alert_name: '',
			alert_mobilephone: '',
			transactionType: 'member',
			prospectiveMember: {
				prospective_name: '',
				prospective_mobilephone: '',
				status: false,
			}
		}
	},
	computed: {
		...mapState('commonList', ['mitraMLM', 'prospectiveMitra']),
		...mapState('transactionList', ['memberHasTransaction']),

		kotaprovinsi() {
			let data = ''
			if (this.mitraMLM.city_name && this.mitraMLM.province_name) {
				data = this.mitraMLM.city_name + ', ' + this.mitraMLM.province_name
			} else if (this.mitraMLM.city_name && !this.mitraMLM.province_name) {
				data = this.mitraMLM.city_name
			} else {
				data = '-'
			}
			return data;
		}
	},
	methods: {
		...mapActions('commonList', ['getmitraMLM']),
		...mapActions('cart', ['getregisterItem']),
		...mapMutations('cart', ['step_up',]),
		...mapMutations('commonList', ['resetmitraMLM', 'setProspectiveMitra', 'resetProspectiveMitra']),
		...mapActions('transactionList', ['getMemberHasTransaction']),

		checkMitra() {
			this.alert_mitra = ''
			if (!this.mitra_code) {
				this.alert_mitra = 'Kode Mitra tidak boleh kosong'
			} else {
				this.getmitraMLM({
					member_network_mid: this.mitra_code
				}).then(() => {
					if (!this.mitraMLM.status) {
						this.alert_mitra = 'Kode Mitra tidak ditemukan'
					} else if (this.mitraMLM.is_active == '0') {
						this.alert_mitra = 'ID tersebut sudah expired, dan tidak bisa digunakan'
					}
				})
			}
		},
		checkProspectiveMitra() {
			this.resetProspectiveMitra()
			this.alert_name = ''
			this.alert_mobilephone = ''
			if (this.prospectiveMember.name == '') {
				this.alert_name = 'Nama calon mitra tidak boleh kosong'
			} else if (!/^[a-zA-Z\s]+$/.test(this.prospectiveMember.name)) {
				this.alert_name = 'Nama calon mitra hanya boleh diisi dengan huruf'
			}

			if (this.prospectiveMember.mobilephone == '') {
				this.alert_mobilephone = 'No. HP calon mitra tidak boleh kosong'
			} else if (!/^[0-9]+$/.test(this.prospectiveMember.mobilephone)) {
				this.alert_mobilephone = 'No. HP calon mitra hanya boleh diisi dengan angka'
			} else if (this.prospectiveMember.mobilephone.length < 10 || this.prospectiveMember.mobilephone.length > 13) {
				this.alert_mobilephone = 'No. HP calon mitra harus diantara 10-13 digit'
			}

			if (this.alert_name == '' && this.alert_mobilephone == '') {
				this.prospectiveMember.status = true
			}
		},
		lanjut() {
			this.prospectiveMember.transactionType = this.transactionType
			this.setProspectiveMitra(this.prospectiveMember)
			this.getregisterItem().then(() => {
				this.step_up()
			})
		},
		changeTransaction(type) {
			this.resetProspectiveMitra()
			this.resetmitraMLM()
			this.transactionType = type
			// reset data
			this.mitra_code = ''
			this.alert_mitra = ''
			this.prospectiveMember = {
				name: '',
				mobilephone: '',
				status: false,
			}
		}
	},
	created() {
		this.resetProspectiveMitra()
		this.resetmitraMLM()
		this.getMemberHasTransaction()
	}
};
</script>